<template>
  <div class="contact-card">
    <div class="contact-card__header">
      <div class="contact-card__details">
        <p
          class="text-heading-l"
          v-text="rep.name"
        />

        <p
          v-if="region"
          class="text-body-s-regular"
          v-text="region"
        />

        <p
          v-if="rep.title"
          class="text-body-s-regular"
          v-text="rep.title"
        />
      </div>

      <btn
        v-if="rep.email"
        class="contact-card__cta"
        :label="$string('general.find_rep.callback.toggle')"
        modifiers="secondary center"
        @click="$emit('callback', rep)"
      />
    </div>
    <contact-details
      :email="rep.email"
      :phone="rep.phone"
    />
  </div>
</template>

<script>

/**
 * Vue: Contact card (contact-card)
 * -----------------------------------------------------------------------------
 * Contact Card.
 *
 * @param {Object} rep - Rep data object.
 * @param {String} region - Rep selected region.
 *
 */

import Btn from '~global/btn/btn'
import ContactDetails from '~async/contact-details/contact-details'

export default {
  name: 'ContactCard',

  components: {
    Btn,
    ContactDetails,
  },

  props: {
    rep: {
      type: Object,
      default: () => ({
        name: '',
        title: '',
        phone: '',
        email: '',
      }),
    },
    region: {
      type: String,
      default: () => '',
    },
  },

  emits: {
    callback: (rep) => {
      if (rep.email) {
        return true
      }

      console.warn('Invalid callback event payload!')
      return false

    },
  },
}
</script>

<style lang="scss">
@import './contact-card';
</style>
